import Service from "../service";
import AuthService from "../AuthService";


const Common = {
  getDistrict(id) {
    return AuthService.get(`/api/get-district/${id}`);
  },
  getParty() {
    return AuthService.get('/api/get-party')
  },
  getPartyList() {
    return AuthService.get('/api/get-party-list')
  },
  getProvince() {
    return AuthService.get('/api/get-province');
  },
  getHistoryLogin(page) {
    return AuthService.get('/api/get-history-login?page='+page)
    // return AuthService.get('/api/user-activity')
  },
  getHistoryLoginExcel() {
    return AuthService.get('/api/get-history-login-excel')
  },
  getOrganization() {
    return AuthService.get('/api/get-organization')
  },
  getOrganizationParty(id) {
    return AuthService.get('/api/get-organization-party?party_id='+id)
  },
  getSearchHistoryLogin(page,organization_id,user_name,date_start,date_end) {
    if(!organization_id) {
      organization_id = '';
    }
    if(!user_name) {
      user_name = '';
    }
    if(!date_start) {
      date_start = '';
    }
    if(!date_end) {
      date_end = '';
    }
    return AuthService.get('/api/get-search-history-login?page='+page+'&organization_id='+organization_id+
      '&user_name='+user_name+
      '&date_start='+date_start+
      '&date_end='+date_end
    )
  },
  getDataSearchTools() {
    return AuthService.get('/api/get-data-search-tools');
  },
  getDataOrganizationSearchTools(id) {
    return AuthService.get('/api/get-data-organization-search-tools?id='+id.id)
  },
  getStatSearchOrganization() {
    return AuthService.get('/api/get-stat-search-organization')
  },
  getStatSearchDateOrganization(data) {
    return AuthService.get('/api/get-stat-search-date-organization?start_date='+data.start_date+'&end_date='+data.end_date)
  },
  getStatSearchGroupMeds() {
    return AuthService.get('/api/get-stat-search-group-meds')
  },
  getStatSearchDateGroup(data) {
    return AuthService.get('/api/get-stat-search-date-group?start_date='+data.start_date+'&end_date='+data.end_date)
  },
  getStatSearchDateTool(data) {
    return AuthService.get('/api/get-stat-search-date-tool?start_date='+data.start_date+'&end_date='+data.end_date)
  },
  getNumberSearchingToday() {
    return AuthService.get('/api/get-number-search-today')
  },
  getNumberViewToday() {
    return AuthService.get('/api/get-number-view-today')
  },
  getNumberPrintingToday() {
    return AuthService.get('/api/get-number-print-today')
  },
  getNumberLoginToday() {
    return AuthService.get('/api/get-number-login-today')
  },
  saveQA(data) {
    return AuthService.post('/api/save-qa', data)
  },
  getQa(data) {
    return AuthService.get('/api/get-qa')
  },
  getLike() {
    return AuthService.get('/api/get-like')
  }
};

export default Common;
